import api from './api';
import {
  Supplier,
  SupplierBatchImportResponse,
  SupplierListResponse,
  SupplierQuickCreatePayload,
  SupplierUpsertPayload,
} from '../types';

export const suppliersApi = {
  async list(params?: {
    search?: string;
    skip?: number;
    limit?: number;
    signal?: AbortSignal;
  }): Promise<SupplierListResponse> {
    const response = await api.get<SupplierListResponse>('/api/suppliers/', {
      params: {
        search: params?.search ?? '',
        skip: params?.skip ?? 0,
        limit: params?.limit ?? 20,
      },
      signal: params?.signal,
    });
    return response.data;
  },

  async getById(supplierId: number): Promise<Supplier> {
    const response = await api.get(`/api/suppliers/${supplierId}`);
    return response.data;
  },

  async create(payload: SupplierUpsertPayload): Promise<Supplier> {
    const response = await api.post('/api/suppliers/', payload);
    return response.data;
  },

  async quickCreate(payload: SupplierQuickCreatePayload): Promise<Supplier> {
    const response = await api.post('/api/suppliers/quick-create', payload);
    return response.data;
  },

  async update(supplierId: number, payload: Partial<SupplierUpsertPayload>): Promise<Supplier> {
    const response = await api.put(`/api/suppliers/${supplierId}`, payload);
    return response.data;
  },

  async remove(supplierId: number): Promise<void> {
    await api.delete(`/api/suppliers/${supplierId}`);
  },

  async importBatch(file: File): Promise<SupplierBatchImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/api/suppliers/import-batch', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
